<template>
  <div
    :class="[
      `ritm-tree ${this.module}`,
      { dark: theme === 'dark-theme' },
      { cicled },
      { bordered }
    ]"
    v-loading="!isTreeLoaded"
  >
    <div class="tree-controls">
      <r-search-input
        :filter-text="filterText"
        :is-loading="filterLoading"
        @change="e => filterChange(e)"
      />
      <div
        v-if="editMode && module === 'constructorTree'"
        class="tree-controls__buttons"
      >
        <el-tooltip content="Создать папку" placement="top">
          <el-button
            class="r-button plain"
            circle
            @click="createFolder"
            size="mini"
            type="success"
            icon="el-icon-plus"
          />
        </el-tooltip>
      </div>
    </div>

    <!-- <div class="ritm-tree__layer-control" v-if="module === 'mapTree'">
      <el-select
        v-model="layerFilter"
        size="mini"
        class="r-select"
        @change="refreshData"
        placeholder="Filter"
      >
        <el-option
          v-for="item in layerFilters"
          :key="item.value"
          :label="item.title"
          :value="item.value"
        />
      </el-select>
    </div> -->

    <div :id="module" class="tree-wrapper" />
  </div>
</template>

<script>
import InfiniteTree from "infinite-tree";
import { notifyFactory, errorParser } from "@/utils";
import debounce from "lodash.debounce";
import renderer from "./modules/renderer.js";
import {
  layerFilters,
  customFilter,
  preventDefaultEvent,
  stopPropagationEvent,
  clickHandler
} from "./helpers/";

export default {
  props: {
    "active-layers": String,
    "active-layers-id": String,
    bordered: Boolean,
    cicled: Boolean,
    data: Array,
    "edit-mode": Boolean,
    "is-active": Function,
    "is-loading": Function,
    "toggle-tool": Function,
    "show-tools": Boolean,
    module: String,
    "node-click-handler": Function
  },
  data() {
    return {
      isTreeLoaded: false,
      mouseTarget: {},
      tooltipElem: null,
      preventTooltip: false,

      token: this.$store.state.auth.token,
      currentProfileId: this.$store.state.profiles.currentProfile.id,
      tree: {},
      droppable: false,
      expandedNodes: [],

      filterText: "",
      filterLoading: false,

      checkedNodes: [],
      activeLayersIdInitial: "",
      loadingLayersId: [],

      dragEnterTime: null,
      dragHoveredItem: { nodeId: "", pseudo: "" },
      initialDragHoveredItem: { nodeId: "", pseudo: "" },

      renameModeNodeId: "",
      newNodeName: "",

      formatsList: [],
      formatsLayout: [],

      topNodeId: "",
      treeReady: false,

      layerFilter: "all",
      layerFilters
    };
  },
  watch: {
    "$store.state.profiles.isTreeLoaded": {
      handler: function(val) {
        this.isTreeLoaded = val;
      },
      deep: true,
      immediate: true
    },
    clearCheckedProfile: {
      handler: function(val) {
        if (!val) return;
        if (!this.editMode || this.module !== "constructorTree") return;
        this.checkedNodes.splice(0, this.checkedNodes.length);
        this.$store.state.profiles.profileConstructor.clearChecked.profile = false;
        setTimeout(() => this.filterTree(this.filterText), 100);
      },
      deep: true,
      immediate: true
    },
    clearCheckedDs: {
      handler: function(val) {
        if (!val) return;
        if (!this.editMode || this.module !== "constructorDsTree") return;
        this.checkedNodes.splice(0, this.checkedNodes.length);
        this.$store.state.profiles.profileConstructor.clearChecked.dsTree = false;
        setTimeout(() => this.tree.filter(this.filterText), 100);
      },
      deep: true,
      immediate: true
    },
    "$store.state.profiles.profileConstructor.profileId": {
      handler: function(val) {
        if (val && this.module === "constructorTree") {
          this.currentProfileId = val;
        }
      },
      deep: true,
      immediate: true
    },
    filterText(val) {
      this.filterLoading = true;
      this.filterTree(val);
    },
    data(val) {
      this.tree.loadData(val);
      setTimeout(() => this.filterTree(this.filterText), 100);
    },
    activeLayersId(val) {
      if (val) {
        this.tree.updateNode(this.tree.getNodeById(val));
        if (this.activeLayersIdInitial !== val) {
          this.tree.updateNode(
            this.tree.getNodeById(this.activeLayersIdInitial)
          );
        }
        this.activeLayersIdInitial = val;
        setTimeout(() => this.tree.filter(this.filterText), 10);
      }
    },
    loadingLayers(val) {
      if (this.module === "mapTree") {
        this.loadingLayersId = val;
        this.filterTree(this.filterText);
      }
    },
    dragHoveredItem(val) {
      if (
        val.pseudo === this.initialDragHoveredItem.pseudo &&
        val.nodeId === this.initialDragHoveredItem.nodeId
      )
        return;
      this.initialDragHoveredItem = val;
    },
    initialDragHoveredItem() {
      setTimeout(() => this.tree.filter(this.filterText), 100);
    },
    renameModeNodeId(val) {
      if (val) {
        const currentNode = this.tree.getNodeById(val);

        const input = document
          .querySelector(`#${this.module}`)
          .querySelector(".ritm-input");
        input.addEventListener("click", e => stopPropagationEvent(e));
        input.addEventListener("keydown", e => this.inputOnKeyDown(e));
        input.addEventListener("blur", e => this.inputOnBlur(e));
        input.focus();
        input.value = currentNode.name;
      }
    },
    expandedNodes(val) {
      if (
        this.module === "constructorDsTree" ||
        this.module === "constructorTree"
      )
        return;
      this.$store.commit("SET_TREE_EXPANDED_NODES", val);
    }
  },
  computed: {
    clearCheckedDs() {
      return this.$store.state.profiles.profileConstructor.clearChecked.dsTree;
    },
    clearCheckedProfile() {
      return this.$store.state.profiles.profileConstructor.clearChecked.profile;
    },
    activeLayersMap() {
      return this.$store.state.map.activeLayers;
    },
    loadingLayers() {
      return this.$store.state.map.loadingLayers;
    },
    hasBook() {
      return this.$store.getters.hasModule("Book");
    },
    mapHasEditor() {
      return this.$store.getters.hasInstrument("Map", "Editor");
    },
    mapHasStyles() {
      return this.$store.getters.hasInstrument("Map", "Styles");
    },
    mapHasFilters() {
      return this.$store.getters.hasInstrument("Map", "Filters");
    },
    mapHasHeatmaps() {
      return this.$store.getters.hasInstrument("Map", "Heatmaps");
    },
    mapHasDiagrams() {
      return this.$store.getters.hasInstrument("Map", "Diagrams");
    },
    theme() {
      return this.$store.state.theme;
    }
  },
  methods: {
    filterChange(e) {
      this.filterText = e;
    },
    getTopNode: debounce(function() {
      let topNode;

      switch (this.module) {
        case "mapTree":
          topNode = this.tree.getNodeFromPoint(50, 200);
          this.topNodeId = topNode ? topNode.id : "";
          break;
        case "bookTree":
          topNode = this.tree.getNodeFromPoint(50, 200);
          this.topNodeId = topNode ? topNode.id : "";
          break;
      }
    }, 200),
    refreshData() {
      this.filterTree(this.filterText);
    },
    expandToNode(nodeId) {
      const activeNode = this.tree.getNodeById(nodeId);

      if (
        activeNode &&
        activeNode.parent_id &&
        !activeNode.parent.state.open &&
        this.expandedNodes.indexOf(activeNode.parent_id) === -1
      ) {
        this.expandedNodes.push(activeNode.parent_id);
        if (activeNode.parent && activeNode.parent.parent_id)
          this.expandToNode(activeNode.parent.id);
      }
    },
    // TODO: Merge to one small function, devide from filter
    mapExpandToNodes(parentNode) {
      parentNode.children.forEach(e => {
        if (this.isActive(e.id) && !e.state.open) this.expandToNode(e.id);
        if (e.children && e.children.length) this.mapExpandToNodes(e);
      });
    },
    filterTree: debounce(function(value) {
      this.tree.filter(node => customFilter(this, node, value), {
        includeDescendants: false
      });
      this.expandedNodes.forEach(e => {
        this.tree.openNode(this.tree.getNodeById(e), { silent: true });
      });
      if (
        (this.module === "mapTree" || this.module === "bookTree") &&
        this.topNodeId &&
        !this.treeReady
      ) {
        this.tree.scrollToNode(this.tree.getNodeById(this.topNodeId));
        this.treeReady = true;
      }
      this.filterLoading = false;
    }, 200),
    async createFolder() {
      const newFolder = [{ name: this.$t("tree:create:new-folder") }];
      const currentProfileId = this.$store.state.profiles.currentProfile.id;
      const options = {
        url: "user/profile?",
        data: { id: this.currentProfileId, profile_trees: newFolder }
      };

      try {
        await this.$store.dispatch("POST_REQUEST", options);
        let user = await this.$store.dispatch("REQUEST", { url: `user` });
        if (this.currentProfileId === currentProfileId) {
          this.$store.commit("SET_CURRENT_PROFILE", user.data.current_profile);
        }
        this.$store.commit("CLEAR_CHECKED_DATA");
        this.$store.commit("PROFILE_TREE_UPDATED", {
          action: "toggle",
          value: true
        });
        const title = this.$t("profile:change-success-title");
        const message = this.$t("profile:change-success");
        this.$notify(notifyFactory("info", title, message));
      } catch (e) {
        console.log(e);
      }
    },
    toggleLayersSettings(e, data) {
      e.stopPropagation();
      this.toggleTool("settings", data);
    },
    toggleLayersEditor(e, data) {
      e.stopPropagation();
      this.toggleTool("editor", data);
    },
    toggleLayersBook(e, data) {
      e.stopPropagation();
      const window = this.$store.state.interface.overheadLayout.find(
        w => w.childComponent === "Book" && w.sourcename === data.id
      );

      if (window) {
        this.$store.commit("CLOSE_OVERHEAD_WINDOW", window.i);
      } else {
        let options = {
          title: "Book",
          type: "Book",
          sourcename: data.source_id,
          id: data.id,
          datatype: data.datatype
        };
        this.$store.commit("ADD_NEW_OVERHEAD_WINDOW", options);
      }
    },
    flyToLayerHandler(e, data) {
      e.stopPropagation();
      this.toggleTool("fly-to-layer", data);
    },
    enableRouterHandler(e, data) {
      e.stopPropagation();

      this.$store
        .dispatch("POST_OSRM_REQUEST", { id: data.source_id })
        .then(response => {
          // eslint-disable-next-line
          const message = `Запрос на включение маршрутизатора отправлен. Номер задачи - ${response.data.task_id}`;
          this.$notify(notifyFactory("success", "Запрос отправлен", message));
          this.$store.commit("ADD_ACTIVE_TASK", {
            task_id: response.data.task_id,
            type: "other",
            description: `Включение маршрутизатора для ИД - ${data.name}`,
            source_id: data.source_id
          });
        })
        .catch(error => {
          const message =
            "Запрос на включение маршрутизатора не отправлен. Повторите попытку";
          const title = "Запрос не отправлен";
          errorParser.call(this, error, message, title);
        });
    },
    startCalcHandler(e, data) {
      e.stopPropagation();

      // eslint-disable-next-line
      const url = `ltm_machine/start/${data.source_id}?step_interval=300&step_count=12`;
      this.$store
        .dispatch("POST_REQUEST", { url })
        .then(response => {
          // eslint-disable-next-line
          const message = `Запрос на выполнение расчета отправлен. Номер задачи - ${response.data.task_id}`;
          this.$notify(notifyFactory("success", "Запрос отправлен", message));
          this.$store.commit("ADD_ACTIVE_TASK", {
            task_id: response.data.task_id,
            type: "calc",
            description: `Выполнение расчета для ИД - ${data.name}`,
            source_id: data.source_id
          });
        })
        .catch(error => {
          const message =
            "Запрос на выполнение расчета не отправлен. Повторите попытку";
          const title = "Запрос не отправлен";
          errorParser.call(this, error, message, title);
        });
    },
    toggleAllChildNodes(node, method) {
      const index = this.checkedNodes.indexOf(node);

      switch (method) {
        case "push":
          if (index === -1) {
            this.checkedNodes.push(node);
            if (node.children && node.children.length) {
              node.children.forEach(e => this.toggleAllChildNodes(e, "push"));
            }
          }
          break;
        case "splice":
          if (index !== -1) {
            this.checkedNodes.splice(index, 1);
            if (node.children && node.children.length) {
              node.children.forEach(e => this.toggleAllChildNodes(e, "splice"));
            }
          }
          break;
      }
    },
    checkNodes(node) {
      const index = this.checkedNodes.indexOf(node);

      if (index === -1) {
        this.checkedNodes.push(node);
        if (node.children && node.children.length) {
          node.children.forEach(e => this.toggleAllChildNodes(e, "push"));
        }
      } else {
        this.checkedNodes.splice(index, 1);
        if (node.children && node.children.length) {
          node.children.forEach(e => this.toggleAllChildNodes(e, "splice"));
        }
      }
    },
    enterRenameMode(nodeId) {
      const currentNode = this.tree.getNodeById(nodeId);

      this.renameModeNodeId = nodeId;
      this.tree.updateNode(currentNode);
      document
        .querySelector(`#${this.module}`)
        .addEventListener("dragstart", preventDefaultEvent);
    },
    exitRenameMode(e, nodeId) {
      e.stopPropagation();
      const currentNode = this.tree.getNodeById(nodeId);

      this.renameModeNodeId = "";
      this.tree.updateNode(currentNode);
      document
        .querySelector(`#${this.module}`)
        .removeEventListener("dragstart", preventDefaultEvent);
    },
    saveDsName(e, node) {
      e.stopPropagation();
      if (node.name !== this.newNodeName) {
        const changedLayer = [{ id: node.id, name: this.newNodeName }];
        this.updateProfileTreeItem(changedLayer);
        node.name = this.newNodeName;
      }
      this.renameModeNodeId = "";
      this.newNodeName = "";
      this.exitRenameMode(e, node.id);
    },
    inputOnKeyDown(e) {
      const target = e.target || e.srcElement;
      this.newNodeName = target.value;
      const currentNode = this.tree.getNodeById(target.getAttribute("data-id"));

      if (e.key === "Enter") this.saveDsName(e, currentNode);
      if (e.key === "Escape") this.exitRenameMode(e, this.renameModeNodeId);
    },
    inputOnBlur(e) {
      if (this.renameModeNodeId) {
        const target = e.target || e.srcElement;
        this.newNodeName = target.value;
        const currentNode = this.tree.getNodeById(
          target.getAttribute("data-id")
        );
        this.saveDsName(e, currentNode);
      }
    },
    togglerHandler(nodeId) {
      if (
        this.module === "constructorDsTree" ||
        this.module === "constructorTree"
      )
        return;
      let index;
      if (this.expandedNodes) {
        index = this.expandedNodes.indexOf(nodeId);

        if (index === -1) {
          this.expandedNodes.push(nodeId);
        } else {
          this.expandedNodes.splice(index, 1);
        }
      }
    },
    handleDragEnter() {
      const date = new Date();
      this.dragEnterTime = date.getTime();
      if (this.module === "constructorTree") return true;

      return false;
    },
    handleDragLeave() {
      this.dragHoveredItem = { nodeId: "", pseudo: "" };
    },
    handleDragOver(e) {
      let target = e.target || e.srcElement;
      let nodeId = target.getAttribute("data-id");

      if (!nodeId) {
        this.dragHoveredItem = { nodeId: "", pseudo: "" };
        return;
      }

      let currentNode = this.tree.getNodeById(nodeId);

      if (e.offsetY < 6) {
        this.dragHoveredItem = { nodeId, pseudo: "before" };
      } else if (e.offsetY > 20) {
        this.dragHoveredItem = { nodeId, pseudo: "after" };
      } else {
        this.dragHoveredItem = { nodeId, pseudo: "" };
      }

      if (
        currentNode &&
        currentNode.children &&
        currentNode.children.length &&
        !this.dragHoveredItem.pseudo
      ) {
        const date = new Date();
        const delay = date.getTime() - this.dragEnterTime;
        if (delay > 1300 && delay < 1500) {
          this.tree.openNode(currentNode);
        }
      }
    },
    nodeDrop(e, options) {
      let dragNodeId = options.draggableTarget.getAttribute("data-id");
      const dragNode = this.tree.getNodeById(dragNodeId);
      const dropNode = options.node;

      if (dragNode === dropNode) {
        this.dragHoveredItem = { nodeId: "", pseudo: "" };
        return;
      }

      let changedLayer = [];

      switch (this.dragHoveredItem.pseudo) {
        case "before":
        case "after":
          if (!dropNode.parent_id) {
            changedLayer.push({ id: dragNode.id, parent_id: null });
          } else {
            changedLayer.push({
              id: dragNode.id,
              parent_id: dropNode.parent_id
            });
          }
          this.tree.moveNodeTo(dragNode, dropNode.parent);
          break;
        default:
          changedLayer.push({ id: dragNode.id, parent_id: dropNode.id });
          this.tree.moveNodeTo(dragNode, dropNode);
          break;
      }
      this.updateProfileTreeItem(changedLayer);
      this.dragHoveredItem = { nodeId: "", pseudo: "" };
    },
    async updateProfileTreeItem(changedLayer) {
      if (!changedLayer) return;
      const options = {
        url: "user/profile?",
        data: { id: this.currentProfileId, profile_trees: changedLayer }
      };

      try {
        await this.$store.dispatch("POST_REQUEST", options);
        this.$store.commit("PROFILE_TREE_UPDATED", {
          action: "dnd",
          value: true
        });
        this.$store.commit("CLEAR_CHECKED_DATA", true);
        const title = this.$t("profile:change-success-title");
        const message = this.$t("profile:change-success");
        this.$notify(notifyFactory("info", title, message));
      } catch (e) {
        console.log(e);
      }
    },
    showTooltip: debounce(function() {
      if (!this.mouseTarget || this.preventTooltip) return;
      const nodeId = this.mouseTarget.getAttribute("data-id");
      const node = this.tree.getNodeById(nodeId);

      if (!node) return;
      const nodeName = node.name;

      let tooltipHtml = nodeName;

      if (!tooltipHtml) return;
      this.tooltipElem = document.createElement("div");
      this.tooltipElem.className = "ritm-tree__tooltip";
      this.tooltipElem.innerHTML = tooltipHtml;
      document.body.append(this.tooltipElem);

      let coords = this.mouseTarget.getBoundingClientRect();
      let left = coords.left + this.mouseTarget.offsetWidth + 8;
      if (left < 0) left = 0;
      let top = coords.top - this.tooltipElem.offsetHeight + 28;
      if (top < 0) {
        top = coords.top + this.mouseTarget.offsetHeight + 28;
      }

      this.tooltipElem.style.left = left + "px";
      this.tooltipElem.style.top = top + "px";
    }, 1000),
    removeTooltip() {
      this.preventTooltip = true;
      if (this.tooltipElem) {
        this.tooltipElem.remove();
        this.tooltipElem = null;
      }
      let treeTooltips = document.querySelectorAll(".ritm-tree__tooltip");
      if (treeTooltips.length) treeTooltips.forEach(e => e.remove());
    },
    handleMouseOver(e) {
      const target = e.target || e.srcElement;

      this.mouseTarget = target.closest(".infinite-tree-item");
      if (!this.mouseTarget) {
        this.removeTooltip();
        return;
      }
      this.preventTooltip = false;
      this.showTooltip();
    },
    openDsExport(e, dsObject) {
      if (!dsObject.source_id) dsObject.source_id = dsObject.id;
      this.$store.commit("SET_DS_EXPORT_ITEM", dsObject);
      this.$store.commit("OPEN_MODAL_WINDOW", "ds-export");
    }
  },
  mounted() {
    if (this.editMode && this.module === "constructorTree") {
      this.droppable = {
        accept: (e, options) => this.handleDragEnter(e, options),
        drop: (e, options) => this.nodeDrop(e, options)
      };
      document
        .querySelector(`#${this.module}`)
        .addEventListener("dragover", e => this.handleDragOver(e));
      document
        .querySelector(`#${this.module}`)
        .addEventListener("dragleave", e => this.handleDragLeave(e));
    } else {
      document
        .querySelector(`#${this.module}`)
        .addEventListener("dragstart", e => e.preventDefault());
    }
    this.tree = new InfiniteTree({
      el: document.querySelector(`#${this.module}`),
      selectable: false,
      droppable: this.droppable,
      shouldLoadNodes: function(parentNode) {
        return !parentNode.hasChildren() && parentNode.loadNodes;
      },
      loadNodes: function(parentNode) {
        const nodes = [];
        nodes.length = 1000;
        for (let i = 0; i < nodes.length; ++i) {
          nodes[i] = {
            id: `${parentNode.id}.${i}`,
            name: `${parentNode.name}.${i}`,
            loadOnDemand: true
          };
        }
      },
      nodeIdAttr: "data-id",
      rowRenderer: (node, treeOptions) => renderer(node, treeOptions, this),
      noDataText: `${this.$t("no-data")}`
    });
    this.tree.on("click", e => clickHandler(this, e));
    this.tree.loadData(this.data);

    if (this.module === "mapTree" || this.module === "bookTree") {
      this.topNodeId = this.$store.state.profiles.treeScrollNode;

      document
        .querySelector(`#${this.module}`)
        .addEventListener("mousemove", () => this.getTopNode());
    }

    if (
      this.module !== "constructorDsTree" &&
      this.module !== "constructorTree"
    ) {
      this.expandedNodes = this.$store.state.profiles.treeExpandedNodes;
    }

    if (this.activeLayersId) this.activeLayersIdInitial = this.activeLayersId;

    document
      .querySelector(`#${this.module}`)
      .addEventListener("mouseover", e => this.handleMouseOver(e));

    document
      .querySelector(`#${this.module}`)
      .addEventListener("mouseout", () => this.removeTooltip());
  },
  beforeDestroy() {
    if (
      (this.module === "mapTree" || this.module === "bookTree") &&
      this.topNodeId
    ) {
      this.$store.commit("SAVE_TREE_SCROLL_NODE", this.topNodeId);
    }
  }
};
</script>

<style lang="scss" src="./tree.scss"></style>

<i18n>
{
  "ru": {
    "no-data": "Данные отсутствуют",

    "settings": "Настройки",
    "book": "Справочник",
    "editor": "Редактор геометрии",
    "flytolayer": "Перелететь к слою",
    "enablerouter": "Запустить маршрутизатор",
    "startcalc": "Запустить расчет",
    "tree:create:new-folder": "Новая папка",

    "profile:change-success-title": "Уведомление!",
    "profile:change-success": "Профиль успешно изменен!"
  },
  "en": {
    "no-data": "No data",
    
    "settings": "Settings",
    "book": "Book",
    "editor": "Editor",
    "flytolayer": "Fly To Layer",
    "enablerouter": "Start Router",
    "startcalc": "Start Calculation",
    "tree:create:new-folder": "New folder",

    "profile:change-success-title": "Notification!",
    "profile:change-success": "Profile changed successfully!"
  }
}
</i18n>
